module.exports = __webpack_public_path__ + "e0106718/img/comments-icon.fdec7fdb.svg";